import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';

export const EngagementsHistorySearchRequestFilterTabOptions = {
  interest: 'INTERESTED',
  submissions: 'SUBMITTED',
  engagements: 'ENGAGED',
} as const;

export type EngagementsHistorySearchRequestTabValues =
  (typeof EngagementsHistorySearchRequestFilterTabOptions)[keyof typeof EngagementsHistorySearchRequestFilterTabOptions];

export const EngagementsHistorySearchRequestSchema = z.object({
  viewType: z.enum(
    ZodArrayToEnum(
      Object.values(EngagementsHistorySearchRequestFilterTabOptions)
    )
  ),
  page: z.number().nonnegative().int().default(1),
  pageSize: z.number().nonnegative().int().default(10),
});

export type EngagementsHistorySearchRequest = z.infer<
  typeof EngagementsHistorySearchRequestSchema
>;
